import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_32: DocMigration = {
  maxSchemaVersion: "0.0.32",
  apply(json: any) {
    if (json.viewerFilter) {
      const viewerFilter = json.viewerFilter;
      if (!viewerFilter.hasOwnProperty("interiorDimensions")) {
        viewerFilter["interiorDimensions"] = true;
      }
    }

    return json;
  },
};

export default migration_0_0_32;
